import { ReportSummaryItemApi } from "../api/Reports";
import { classNames } from "../utils";

export default function StatusAccent({
  report,
}: {
  report: ReportSummaryItemApi;
}) {
  function isDone() {
    return report.report_status === "DONE";
  }

  return (
    <span
      className={classNames(
        "absolute right-0 block w-1 h-1 rounded-full top-0",
        isDone() ? "bg-green-400" : "bg-red-400"
      )}
    ></span>
  );
}
